
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class ChartTypeSelector extends Vue {
  @Prop({ type: Boolean, required: true }) hasChart!: boolean;
  @Prop({ type: Boolean, required: true }) showChart!: boolean;
  @Prop({ type: String, default: '' }) chartType!: string;
}
